import React, { useState } from "react";
import { Link } from "react-router-dom";

const ProspectsCategories = () => {
  const [activeTab, setActiveTab] = useState("contacted");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  return (
    <div className="bg-[#ffbe1a23] flex justify-between w-[95%] mt-6 ml-4 overflow-auto px-8">
      <Link to="/dashboard/prospects">
        <div
          className={`relative py-4 px-10 text-[12px] cursor-pointer ${
            activeTab === "contacted" ? "active-prospects" : ""
          }`}
          onClick={() => handleTabClick("contacted")}
        >
          To be contacted <span className="text-[#828282]">{"(32)"}</span>
          <div
            className={`${activeTab === "contacted" ? "active-underline" : ""}`}
          ></div>
        </div>
      </Link>
      <Link to="/dashboard/prospects/pending-visits">
        <div
          className={`relative py-4 px-10 text-[12px] cursor-pointer ${
            activeTab === "pending" ? "active-prospects" : ""
          }`}
          onClick={() => handleTabClick("pending")}
        >
          Pending Visits <span className="text-[#828282]">{"(10)"}</span>
          <div
            className={`${activeTab === "pending" ? "active-underline" : ""}`}
          ></div>
        </div>
      </Link>
      <Link to="/dashboard/prospects/negotiation">
        <div
          className={`relative py-4 px-10 text-[12px] cursor-pointer ${
            activeTab === "negotiation" ? "active-prospects" : ""
          }`}
          onClick={() => handleTabClick("negotiation")}
        >
          Negotiation <span className="text-[#828282]">{"(10)"}</span>
          <div
            className={`${
              activeTab === "negotiation" ? "active-underline" : ""
            }`}
          ></div>
        </div>
      </Link>
      <Link to="/dashboard/prospects/inactive">
        <div
          className={`relative py-4 px-10 text-[12px] cursor-pointer ${
            activeTab === "inactive" ? "active-prospects" : ""
          }`}
          onClick={() => handleTabClick("inactive")}
        >
          Inactive <span className="text-[#828282]">{"(10)"}</span>
          <div
            className={`${activeTab === "inactive" ? "active-underline" : ""}`}
          ></div>
        </div>
      </Link>
      <Link to="/dashboard/prospects/win">
        <div
          className={`relative py-4 px-10 text-[12px] cursor-pointer ${
            activeTab === "win" ? "active-prospects" : ""
          }`}
          onClick={() => handleTabClick("win")}
        >
          Win <span className="text-[#828282]">{"(10)"}</span>
          <div
            className={`${activeTab === "win" ? "active-underline" : ""}`}
          ></div>
        </div>
      </Link>

      <Link
        to="/dashboard/prospects/closed"
        className={`relative py-4 px-10  text-[12px] cursor-pointer ${
          activeTab === "closed" ? "active-prospects" : ""
        }`}
        onClick={() => handleTabClick("closed")}
      >
        Closed <span className="text-[#828282]">{"(10)"}</span>
        <div
          className={`${activeTab === "closed" ? "active-underline" : ""}`}
        ></div>
      </Link>
    </div>
  );
};

export default ProspectsCategories;
